import React from 'react';
import { motion } from 'framer-motion';
import { ServerCrash, RefreshCcw } from 'lucide-react';
export function ServerErrorPage() {
  return <div className="min-h-screen bg-background text-textMain flex items-center justify-center p-6" data-id="element-7155">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-md w-full bg-surface border border-border rounded-2xl p-8 text-center" data-id="element-7156">
        <div className="w-16 h-16 rounded-full bg-red-500/10 text-red-500 flex items-center justify-center mx-auto mb-6" data-id="element-7157">
          <ServerCrash className="w-8 h-8" data-id="element-7158" />
        </div>
        <h1 className="text-2xl font-bold mb-2" data-id="element-7159">Internal Server Error</h1>
        <p className="text-textMuted mb-8" data-id="element-7160">
          Something went wrong on our end. Our engineering team has been
          notified and is looking into the issue.
        </p>
        <div className="bg-background border border-border rounded-lg p-4 mb-8 text-left" data-id="element-7161">
          <div className="text-xs font-mono text-textMuted" data-id="element-7162">
            Error Code: 500_INTERNAL_SERVER
          </div>
          <div className="text-xs font-mono text-textMuted mt-1" data-id="element-7163">
            Request ID: req_8f7d6c5b4a3
          </div>
        </div>
        <button onClick={() => window.location.reload()} className="w-full py-3 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center justify-center gap-2" data-id="element-7164">
          <RefreshCcw className="w-4 h-4" data-id="element-7165" /> Try Again
        </button>
      </motion.div>
    </div>;
}